import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'productView',
    component: () => import('../views/productView/indexView.vue')
  },
  {
    path: '/product-landscape',
    name: 'productLandscape',
    component: () => import('../views/productLandscape/indexView.vue')
  },
  {
    path: '/photo-collocation',
    name: 'photo-collocation',
    component: () => import('../views/photoCollocation/index.vue')
  },
  {
    path: '/photo-screenshot',
    name: 'photo-screenshot',
    component: () => import('../views/photoCollocation/screenshot.vue')
  },
  {
    path: '/render3d',
    name: 'render3d',
    component: () => import('../views/render3d/index.vue')
  },
  {
    path: '/render3d-demo',
    name: 'render3d-demo',
    component: () => import('../views/render3d/index-demo.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
